import './index.scss';

$(document).ready(function () {
  $('#cta-questions-limit-modal')
    .off('click.questionsLimitModal')
    .on('click.questionsLimitModal', function (e) {
      e.preventDefault();
      $('#js-questions-limit-modal').modal('hide');

      const href = $(this).attr('href');

      if (href) {
        window.open(href, '_blank', 'noopener,noreferrer');
      }
    });
});
